module.exports = __webpack_public_path__ + "img/collection-weddingRingsSoleil.21e20ad.jpg";